import React from "react";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";
import { useI18n } from "@/i18n";

export default function Rules() {
  const { t } = useI18n();
  const r = t.rules;
  const STAY_RULES = r.items;
  return (
    <section
      id="zasady"
      data-testid="rules-section"
      className="relative bg-canvas-soft py-14 md:py-20 overflow-hidden"
    >
      {/* Soft red watercolor sun */}
      <div className="sun-motif w-[520px] h-[520px] -right-32 top-1/2 -translate-y-1/2 opacity-70 hidden md:block" aria-hidden="true" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative">
        <Reveal>
          <p className="overline mb-6">{r.overline}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-ink max-w-3xl">
            {r.headingA} <br />
            <span className="italic">{r.headingB}</span>
          </h2>
        </Reveal>

        <Stagger className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10">
          {STAY_RULES.map((rule, i) => (
            <StaggerItem
              key={rule.title}
              data-testid={`rule-item-${i + 1}`}
              className="border-t border-ink/15 pt-6 flex items-start gap-5"
            >
              <span className="serif text-brand-red text-lg leading-none mt-1 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="serif text-xl md:text-2xl font-light text-ink mb-2 leading-snug">
                  {rule.title}
                </h3>
                <p className="text-ink-muted text-base leading-relaxed">
                  {rule.desc}
                </p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        <Reveal delay={0.3} className="mt-16 md:mt-20">
          <p className="serif italic text-2xl md:text-3xl text-ink-muted max-w-2xl leading-relaxed">
            {r.outro}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
